<template>
    <div>
        <zm-button v-clipboard:copy="previewForm.policy" id="copy-btn" v-show="false"></zm-button>
        <zm-form class="policy-form" :model="form" ref="form" label-position="left" inline>
            <zm-form-item prop="namespace" label="Namespace">
                <zm-select v-model="form.namespace" placeholder="namespace" popper-class="select-popper" filterable
                    class="policy-select" @change="fetchApplication(false)" :loading="optionLoading">
                    <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item prop="application" label="Application">
                <zm-select v-model="form.applicationId" placeholder="application" popper-class="select-popper" filterable
                    class="policy-select" @change="fetchPath" :loading="optionLoading" :width-limit="{ disableTip: true }">
                    <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
                </zm-select>
            </zm-form-item>
            <!-- <zm-form-item prop="path" label="Path">
                <zm-select v-for="(item, index) in search" :key="index" class="select-inline"
                    v-model="search[index]" @change="setOption(index)" clearable>
                    <zm-option v-for="option in filterOption[index]" :key="option.name"
                    :value="option.name"></zm-option>
                </zm-select>
            </zm-form-item> -->
        </zm-form>
        <div id="tree-chart" v-loading="loading"></div>
        <zm-dialog title="Preview" :visible.sync="visible" show-close width="80%">
            <zm-form :inline="true">
                <zm-form-item label="RoleName">
                    {{ previewForm.roleName || '--' }}
                </zm-form-item>
                <zm-form-item label="PolicyName">
                    {{ previewForm.policyName || '--' }}
                </zm-form-item>
            </zm-form>
            <span>before</span>
            <span style="float: right">after</span>
            <differ :value="previewForm.policy" :previous="previewForm.previous" v-if="visible"></differ>
            <zm-input id="textCopy" type="textarea" v-model="previewForm.policy" readonly autosize v-show="false"></zm-input>
            <div slot="footer" class="dialog-footer">
                <!-- <button type="button" id="copybutton" class="zm-button zm-button--primary"
                    ref="copy"
                    @click="handleCopy"
                    data-clipboard-action="copy"
                    data-clipboard-target="#textCopy">Copy</button> -->
                <zm-button size="small" type="danger" plain @click.native.prevent="deleteRoleAndPath"
                :loading="deleteRoleAndPathLoading" v-if="buttonPermission(form.applicationId)">Delete Role And Path
                </zm-button>
                <zm-button size="small" type="danger" plain @click.native.prevent="deleteRoleOnly"
                :loading="deleteRoleOnlyLoading" v-if="buttonPermission(form.applicationId)">Delete Role
                </zm-button>
                <zm-button size="small" type="primary" @click.native.prevent="createRole"
                :loading="createRoleLoading" v-if="!hideAttach && buttonPermission(form.applicationId)">Create Role
                </zm-button>
                <zm-button size="small" type="primary" @click.native.prevent="attachPolicy" :loading="attachPolicyLoading"
                v-if="!hideAttach && buttonPermission(form.applicationId)">Attach
                </zm-button>
                <zm-button size="small" type="primary" plain @click.native.prevent="visible = false">Close
                </zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listNamespace, listApplication, listTreePath, previewPolicy, attachPolicy, deletePolicy, createRole } from '@/api/index'
import { getPermission } from '@/api/permission'
// import Clipboard from 'clipboard'
import Differ from '@/components/differ.vue'
export default {
    name: 'policy',
    components: {
        Differ
    },
    data () {
        return {
            permission: {
                isSuperAdmin: false,
                isSuperOperator: false,
                manageableResources: []
            },
            loading: false,
            createRoleLoading: false,
            attachPolicyLoading: false,
            deleteRoleOnlyLoading: false,
            deleteRoleAndPathLoading: false,
            namespaceList: [],
            applicationList: [],
            form: {
                showDelete: false,
                roleName: '',
                pathId: '',
                namespace: '',
                prefixPath: [{}, {}, {}],
                applicationId: ''
            },
            optionLoading: false,
            pathList: [],
            options: [],
            visible: false,
            previewForm: {
                roleName: '',
                policyName: '',
                previous: '',
                policy: ''
            },
            hideAttach: false,
            option: {
                tooltip: {
                    show: false
                },
                series: [{
                    type: 'tree',
                    roam: true,
                    data: [],
                    left: '2%',
                    right: '2%',
                    top: '8%',
                    bottom: '20%',
                    symbol: 'emptyCircle',
                    symbolSize: 16,
                    orient: 'vertical',
                    expandAndCollapse: false,
                    edgeShape: 'polyline',
                    label: {
                        formatter: function (params) {
                            return params.data.path
                        },
                        position: 'top',
                        // rotate: -90,
                        verticalAlign: 'middle',
                        align: 'right',
                        fontSize: 14
                    },
                    itemStyle: {
                        borderWidth: 4
                    },
                    leaves: {
                        label: {
                            formatter: function (params) {
                                return params.data.path
                            },
                            position: 'bottom',
                            // rotate: -90,
                            verticalAlign: 'middle',
                            align: 'left'
                        }
                    },
                    animationDurationUpdate: 750
                }]
            }
        }
    },
    created () {
        localStorage.path = this.$route.path
        localStorage.params = ''
        if (this.$route.query.params) {
            this.form.namespace = JSON.parse(this.$route.query.params).namespace
            this.form.applicationId = JSON.parse(this.$route.query.params).applicationId
        }
        this.fetchPermission()
        // window.addEventListener('setItem', () => {
        //     this.form.namespace = localStorage.getItem('namespace')
        // })
        this.form.namespace = localStorage.namespace
        this.fetchNamespace()
        this.fetchApplication(true)
        // this.form.applicationId = localStorage.application
        // if (localStorage.application) {
        //     this.fetchPath()
        // }
    },
    watch: {
        'form.namespace' () {
            this.setURL()
        },
        'form.applicationId' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const data = {
                namespace: this.form.namespace,
                applicationId: this.form.applicationId
            }
            var url = `${location.href.split('?params=')[0]}?params=${JSON.stringify(data)}`
            history.pushState({ url: url }, '', url)
            localStorage.params = JSON.stringify(data)
        },
        buttonPermission (appId) {
            return this.permission.manageableResources.indexOf(appId) > -1 || this.permission.manageableResources.indexOf('*') > -1
        },
        fetchPermission () {
            getPermission('policy').then(response => {
                this.permission.isSuperAdmin = response.data.isSuperAdmin
                this.permission.isSuperOperator = response.data.isSuperOperator
                response.data.manageableResources.map(item => {
                    const data = item.split('/')
                    const appData = data[0].split(':')[1].split('|')
                    appData.map(app => {
                        this.permission.manageableResources.push(app)
                    })
                })
            })
        },
        formatJson (obj, prevSpace) {
            var space = '    '
            var lineBreak = '\n'
            if (!prevSpace) {
                prevSpace = ''
            }
            var type = Object.prototype.toString.call(obj)
            if (type === '[object Array]') {
                var arr = []
                for (var key in obj) {
                    arr.push(this.formatJson(obj[key], prevSpace))
                }
                return '[' + lineBreak + prevSpace + space + arr.join(',' + lineBreak + prevSpace + space) + lineBreak + prevSpace + ']'
            } else if (type === '[object Object]') {
                var nextSpace = prevSpace + space
                var arrObject = []
                for (var keyObject in obj) {
                    arrObject.push(nextSpace + '"' + keyObject + '" : ' + this.formatJson(obj[keyObject], nextSpace))
                }
                return '{' + lineBreak + arrObject.join(',' + lineBreak) + lineBreak + nextSpace + '}'
            } else if (type === '[object String]') {
                return '"' + obj + '"'
            } else {
                return obj
            }
        },
        drawChart () {
            this.$nextTick(() => {
                this.chart = this.$echarts.init(document.getElementById('tree-chart'))
                this.chart.dispose()
                var chart = this.$echarts.init(document.getElementById('tree-chart'))
                chart.setOption(this.option)
                window.addEventListener('resize', () => {
                    chart.resize()
                })
                var that = this
                chart.on('click', function (params) {
                    console.log(params.data)
                    if (params.data.enableCreate && !params.data.hasPolicy) {
                        that.hideAttach = false
                        that.form.pathId = params.data.id
                        that.previewPolicy()
                    } else if (!params.data.enableCreate) {
                        that.form.pathId = params.data.id
                        that.hideAttach = true
                        that.previewPolicy()
                        that.$message({
                            type: 'warning',
                            message: 'Cannot attach policy on this node'
                        })
                    } else {
                        that.$message({
                            type: 'info',
                            message: 'Policy has already existed on this node'
                        })
                        that.hideAttach = false
                        that.form.pathId = params.data.id
                        that.previewPolicy()
                    }
                })
            })
        },
        fetchNamespace () {
            if (localStorage.namespaceList) {
                console.log(localStorage.namespaceList)
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                this.optionLoading = true
                listNamespace().then(response => {
                    this.namespaceList = response
                    this.optionLoading = false
                }).catch(() => {
                    this.optionLoading = false
                })
            }
        },
        fetchApplication (isInitial) {
            if (!isInitial) {
                this.form.applicationId = ''
            }
            if (this.form.namespace) {
                this.optionLoading = true
                listApplication(this.form.namespace, '', 'policy').then(response => {
                    this.applicationList = response.data
                    if (isInitial) {
                        this.applicationList.map(item => {
                            if (item.id === localStorage.application) {
                                this.form.applicationId = localStorage.application
                            }
                        })
                        if (this.form.applicationId) {
                            this.fetchPath()
                        }
                    }
                    this.optionLoading = false
                }).catch(() => {
                    this.optionLoading = false
                })
            }
        },
        fetchPath () {
            const data = {
                namespace: this.form.namespace,
                applicationId: this.form.applicationId
            }
            this.loading = true
            listTreePath(data).then(response => {
                // this.pathList = response.data
                this.option.series[0].data = [response.data]
                this.setColor(this.option.series[0].data)
                this.drawChart()
                this.loading = false
            }).catch(err => {
                if (err.response.status === 404) {
                    localStorage.application = ''
                    this.form.applicationId = ''
                }
                this.loading = false
            })
        },
        handlePrefixChange (index) {
            for (var i = 0; i < this.form.prefixPath.length; i++) {
                if (index < i) {
                    this.form.prefixPath[i] = {}
                }
            }
        },
        handleCopy () {
            var btn = document.getElementById('copy-btn')
            btn.click()
            // var input = document.getElementById('textCopy')
            // console.log(input)
            // input.value = this.previewForm.policy
            // console.log(this.previewForm.policy)
            // console.log(input)
            // this.$nextTick(() => {
            //     const copybtn = this.$refs.copy
            //     this.clipboard = new Clipboard(copybtn)
            //     this.showSecret = false
            // })
        },
        previewPolicy () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true
                    this.form.prefixPath.map(item => {
                        this.form.pathId = item.id || this.form.pathId
                    })
                    console.log(this.form.pathId)
                    const { pathId, applicationId } = this.form
                    const data = { pathId, applicationId }
                    previewPolicy(data).then(response => {
                        this.previewForm.roleName = response.roleName
                        this.previewForm.policyName = response.policyName
                        this.previewForm.previous = this.formatJson(JSON.parse(response.previous))
                        this.previewForm.policy = this.formatJson(JSON.parse(response.policy))
                        this.visible = true
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        deleteRoleAndPath () {
            this.$confirm('This will delete the role and the path. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteRoleAndPathLoading = true
                deletePolicy(this.form.pathId, false).then(response => {
                    this.deleteRoleAndPathLoading = false
                    this.visible = false
                    this.fetchPath()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.deleteRoleAndPathLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        deleteRoleOnly () {
            this.$confirm('This will delete the role. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteRoleOnlyLoading = true
                deletePolicy(this.form.pathId, true).then(response => {
                    this.deleteRoleOnlyLoading = false
                    this.visible = false
                    this.fetchPath()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.deleteRoleOnlyLoading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        attachPolicy () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.attachPolicyLoading = true
                    const { pathId, applicationId } = this.form
                    const data = { pathId, applicationId }
                    attachPolicy(data).then(response => {
                        this.visible = false
                        this.$message({
                            type: 'success',
                            message: 'Attach policy success!'
                        })
                        this.attachPolicyLoading = false
                        this.fetchPath()
                    }).catch(() => {
                        this.attachPolicyLoading = false
                    })
                }
            })
        },
        createRole () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // this.$confirm('Please note that the role created here is not available for K8S! Continue?', 'Warning', {
                    //     confirmButtonText: 'Create',
                    //     cancelButtonText: 'Cancel',
                    //     type: 'warning'
                    // }).then(() => {
                        this.createRoleLoading = true
                        const { pathId, applicationId } = this.form
                        const data = { pathId, applicationId }
                        createRole(data).then(response => {
                            this.visible = false
                            this.$message({
                                type: 'success',
                                message: 'Create success'
                            })
                            this.fetchPath()
                            this.createRoleLoading = false
                        }).catch(() => {
                            this.createRoleLoading = false
                        })
                    // }).catch(() => {
                    //     this.$message({
                    //         type: 'info',
                    //         message: 'Create canceled'
                    //     })
                    // })
                } else {
                    this.$message.warning('Please check pathId or applicationId')
                }
            })
        },
        setColor (nodes) {
            nodes.map(item => {
                if (!item.enableCreate) {
                    item.itemStyle = {
                        color: '#747487',
                        borderColor: '#747487'
                    }
                } else if (item.hasPolicy) {
                    item.itemStyle = {
                        color: '#67c23a',
                        borderColor: '#67c23a'
                    }
                } else {
                    item.itemStyle = {
                        color: '#0E71EB',
                        borderColor: '#0E71EB'
                    }
                }
                if (item.children) {
                    this.setColor(item.children)
                }
            })
        }
    }
}
</script>
<style scoped>
.policy-form {
    width: 80%;
}
.policy-select {
  width: 100%;
  text-align: left;
}
#tree-chart {
    height: calc(100vh - 200px);
}
</style>
